import { Component, OnInit } from '@angular/core';
import { LoadConfigService } from '../../../services/load-config.service';
import { DecisionTransportService } from '../../../services/decision-transport.service';
import { InstructionService } from '../../../services/instruction.service';

@Component({
    selector: 'app-button-setup-four',
    templateUrl: './button-setup-four.component.html',
    styleUrls: ['./button-setup-four.component.scss'],
    standalone: false
})
export class ButtonSetupFourComponent implements OnInit {
  keyLabels: string[];
  decisionKeys: string[];

  constructor(
    private loadConfig: LoadConfigService,
    private decisionTransporter: DecisionTransportService,
    private instructionService: InstructionService
  ) {}

  ngOnInit(): void {
    this.decisionKeys = this.loadConfig.getDecisionKeysAgreement();
    this.keyLabels = this.loadConfig.getKeyLabelsAgreement(this.instructionService.getLanguageIdentifier());
  }

  triggerDecision(decision: string | number) {
    this.decisionTransporter.decisionTriggered(decision);
  }
}
